require('../../../../Crud/resources/js/form/inputs/switch.js');

// Ajax post for normal cookies
common.View.create('website::partials.Cookies', {

    onDOMLoad()
    {
        this.initModal();
        this.getAllCookies();
        this.initSendForm();
    },

    getAllCookies() {
        $.get('/get-cookies')
            .done((result) => {
                let acceptedCookies = result.cookies.filter(cookie => cookie.user_accepted);
                let declinedCookies = result.cookies.filter(cookie => !cookie.user_accepted);

                $('.website\\:\\:partials-Modal').data('instance').addCookies(acceptedCookies);
                $('.website\\:\\:partials-Modal').data('instance').removeCookies(declinedCookies);
            });
    },

    initModal()
    {
        // Hide modal, but set to flex. This way we can use the fade effect in CSS and it will be centered
        $('#cookiesModal').css('display', 'flex').hide();

        $('[data-target="#cookiesModal"]')
            .on('click', (event) => {
                $('body').addClass('overflow-hidden')
                    .find('.modals #cookiesModal').fadeIn('fast');

                return false;
            });
    },

    initSendForm()
    {
        this.element.find('form')

            .on('submit', (event) =>
            {
                let allCookies = document.activeElement.getAttribute('name') === 'allCookies' ? 1 : 0;

                $.post('/save-cookies', { allCookies: allCookies })
                    .done(() => {
                        this.element.find('form').hide();

                        // There are checkboxes which also redirect to the cookies module?
                        // If so; we can turn those on automatically
                        let cookieInput = $('[data-target="#cookiesModal"]').data('input');
                        if( cookieInput ) {
                            $('[name^="'+ cookieInput +'"]').prop('checked', true);
                        }

                        this.getAllCookies();
                    });

                // Stop submit
                return false;
            })
            .end();
    }

});

// TODO Critical: Move to own .js?
// Ajax post for modal cookies
common.View.create('website::partials.Modal', {

    onDOMLoad()
    {
        this.initClose();
        this.initSendForm();
    },

    initClose()
    {
        // Click outside of div?
        $('#cookiesModal')
            .on('click', (event) => {
                let container = this.element;

                // Check for click outside div
                if (!container.is(event.target) && container.has(event.target).length === 0) {
                    $('body').removeClass('overflow-hidden')
                        .find('.modals #cookiesModal').fadeOut('fast');
                }
            });

        // Dismiss by close button
        this.element
            .find('[data-dismiss]')
            .on('click', (event) => {
                $('body').removeClass('overflow-hidden')
                    .find('.modals #cookiesModal').fadeOut('fast');
            })
            .end();
    },

    initSendForm()
    {
        this.element.find('form button[type=submit]')

            .on('click', (event) =>
            {
                // Get form data
                let data = this.element.find('form').serializeArray();
                data.push({ name: event.currentTarget.name, value: event.currentTarget.value });

                // Ajax call
                $.post('/save-cookies', data)
                    .done((result) => {
                        // Hide modal
                        $('body').removeClass('overflow-hidden')
                            .find('.modals #cookiesModal').fadeOut('fast');

                        // Hide 'footer' cookies
                        $('.website\\:\\:partials-Cookies').find('form').hide();

                        // There are checkboxes which also redirect to the cookies module?
                        // If so; we can turn those on automatically
                        let cookieInput = $('[data-target="#cookiesModal"]').data('input');
                        if( cookieInput ) {
                            $('[name^="'+ cookieInput +'"]').prop('checked', true);
                        }

                        let acceptedCookies = result.cookies.filter(cookie => cookie.user_accepted);
                        let declinedCookies = result.cookies.filter(cookie => !cookie.user_accepted);

                        this.addCookies(acceptedCookies);
                        this.removeCookies(declinedCookies);

                        // Fire event to update the cookies
                        window.dispatchEvent(new CustomEvent('cookies-accepted'));
                    });

                // Stop submit
                return false;
            })
            .end();
    },

    addCookies(cookies)
    {
        Object.keys(cookies).forEach((key) => {
            let cookie = cookies[key];

            // Check if we need to add JavaScript code
            this.checkAndAddJavascriptCode(cookie.javascript_code);
        });
    },

    removeCookies(cookies)
    {
        Object.keys(cookies).forEach((key) => {
            let cookie = cookies[key];

            // Check if we need to remove JavaScript code
            this.removeJavascriptCode(cookie.javascript_code);
        });
    },

    checkAndAddJavascriptCode(jsCode) {
        // Get the content between the script tags
        const scriptStart = document.getElementById('cookie-scripts-start');
        const scriptEnd = document.getElementById('cookie-scripts-end');
    
        if (!jsCode) {
            return;
        }
    
        if (!scriptStart || !scriptEnd) {
            console.error('Script start or end tags are missing');
            return;
        }
    
        // Parse the jsCode string into a DOM fragment
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = jsCode;
    
        // Loop through all children of the parsed fragment and insert them before the scriptEnd
        Array.from(tempDiv.childNodes).forEach(node => {
            // Only add the node if it's not already in the DOM
            if (!this.isNodeInDOM(node, scriptStart, scriptEnd)) {
                if (node.tagName === 'SCRIPT') {
                    const scriptElement = document.createElement('script');
                    if (node.src) {
                        // If the script is external, set the src attribute
                        scriptElement.src = node.src;
                        scriptElement.async = true;
                    } else {
                        // For inline scripts, copy the text content
                        scriptElement.textContent = node.innerHTML;
                    }
                    scriptEnd.parentNode.insertBefore(scriptElement, scriptEnd);
                } else {
                    // For non-script tags, insert the node as usual
                    scriptEnd.parentNode.insertBefore(node, scriptEnd);
                }
            }
        });
    },
    
    isNodeInDOM(node, scriptStart, scriptEnd) {
        // Check if the node or an identical node exists between scriptStart and scriptEnd
        let currentNode = scriptStart.nextSibling;
    
        while (currentNode && currentNode !== scriptEnd) {
            if (currentNode.isEqualNode(node)) {
                return true;
            }
            currentNode = currentNode.nextSibling;
        }
    
        return false;
    },

    removeJavascriptCode(jsCode) {
        const scriptStart = document.getElementById('cookie-scripts-start');
        const scriptEnd = document.getElementById('cookie-scripts-end');
    
        if (!scriptStart || !scriptEnd) {
            console.error('Script start or end tags are missing');
            return;
        }
    
        // Parse the jsCode string into a DOM fragment
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = jsCode;
    
        // Loop through all children of the parsed fragment and remove them if they exist in the DOM
        Array.from(tempDiv.childNodes).forEach(node => {
            this.removeNodeFromDOM(node, scriptStart, scriptEnd);
        });
    },
    
    removeNodeFromDOM(node, scriptStart, scriptEnd) {
        // Traverse between scriptStart and scriptEnd and remove nodes that match the provided node
        let currentNode = scriptStart.nextSibling;
    
        while (currentNode && currentNode !== scriptEnd) {
            if (currentNode.isEqualNode(node)) {
                currentNode.parentNode.removeChild(currentNode);
                console.log('Node removed from the DOM');
                // Update currentNode after removal
                currentNode = scriptStart.nextSibling;
            } else {
                currentNode = currentNode.nextSibling;
            }
        }
    }

});
